import React, { useState, useMemo } from 'react';
import _ from 'lodash';
import BWAccordion from 'components/shared/BWAccordion/index';
import FormInput from 'components/shared/BWFormControl/FormInput';
import DataTable from 'components/shared/DataTable/index';
import { useFormContext, Controller } from 'react-hook-form';
import { COUPON_PERMISSION, TYPE_ERROR } from 'pages/Coupon/utils/constants';
import { showConfirmModal } from 'actions/global';
import { useDispatch } from 'react-redux';
import CouponRsErrorModal from './modal/CouponRsErrorModal';
import ICON_COMMON from 'utils/icons.common';
import PropTypes from 'prop-types';
import ErrorMessage from 'components/shared/BWFormControl/ErrorMessage';

const CouponRsError = ({ loading, title, disabled }) => {
  const methods = useFormContext();
  const dispatch = useDispatch();
  const [modalError, setModalError] = useState(undefined);

  const columns = useMemo(
    () => [
      {
        header: 'Mã lỗi máy',
        accessor: 'error_code',
      },
      {
        header: 'Tên lỗi máy',
        accessor: 'error_name',
      },
      {
        header: 'Nhóm lỗi',
        accessor: 'error_group_name',
      },
    ],
    [],
  );

  const actions = useMemo(() => {
    return [
      {
        globalAction: true,
        icon: ICON_COMMON.add,
        type: 'success',
        content: 'Chọn lỗi máy',
        permission: COUPON_PERMISSION.SELECT_RS_ERROR,
        hidden: disabled,
        onClick: () => {
          setModalError(true);
        },
      },
      {
        icon: ICON_COMMON.trash,
        color: 'red',
        permission: COUPON_PERMISSION.SELECT_RS_ERROR,
        hidden: disabled,
        onClick: (value) => {
          dispatch(
            showConfirmModal([`Xoá ${value?.error_name} ra khỏi danh sách lỗi ?`], () => {
              const error_list = _.cloneDeep(methods.watch('error_list'));
              methods.setValue(
                'error_list',
                error_list.filter((err) => parseInt(err?.error_id) !== parseInt(value?.error_id)),
              );
              return;
            }),
          );
        },
      },
    ];
  }, []);

  return (
    <BWAccordion isRequired title={title}>
      <div className='bw_frm_box'>
        <div className='bw_col_12'>
          <div className='bw_align_items_center bw_lb_sex'>
            <label className='bw_radio'>
              <FormInput disabled={disabled} type='checkbox' field='is_all_error' />
              <span />
              Áp dụng cho tất cả lỗi máy
            </label>
          </div>
          {!Boolean(methods.watch('is_all_error')) && (
            <div className='bw_flex bw_align_items_center'>
              <label class='bw_radio'>
                <input
                  disabled={disabled}
                  onChange={() => {
                    methods.setValue('is_type_error', TYPE_ERROR.ISAPPOINTERROR);
                  }}
                  checked={methods.watch('is_type_error') === TYPE_ERROR.ISAPPOINTERROR}
                  type='radio'
                  name='bw_type'
                />
                <span></span>Sửa chữa tất cả các lỗi máy trong DS dưới đây
              </label>
              <label class='bw_radio'>
                <input
                  disabled={disabled}
                  onChange={() => {
                    methods.setValue('is_type_error', TYPE_ERROR.ISANYERROR);
                  }}
                  checked={methods.watch('is_type_error') === TYPE_ERROR.ISANYERROR}
                  type='radio'
                  name='bw_type'
                />
                <span></span>Sửa chữa bất kỳ lỗi máy trong DS dưới đây
              </label>
            </div>
          )}
        </div>
      </div>
      <Controller
        control={methods.control}
        name='error_list'
        rules={{
          validate: (value) => {
            if (!Boolean(methods.watch('is_all_error')) && (!value || value.length === 0))
              return 'Lỗi máy áp dụng là bắt buộc';
          },
        }}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <>
            {!Boolean(methods.watch('is_all_error')) && (
              <>
                <DataTable
                  hiddenActionRow
                  noPaging
                  noSelect
                  data={value}
                  columns={columns}
                  loading={loading}
                  actions={actions}
                />
                {error && <ErrorMessage message={error?.message} />}
              </>
            )}
            {modalError && (
              <CouponRsErrorModal
                open={modalError}
                value={value}
                onChange={onChange}
                onClose={() => {
                  setModalError(false);
                }}
              />
            )}
          </>
        )}
      />
    </BWAccordion>
  );
};

CouponRsError.propTypes = {
  title: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default CouponRsError;
